import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';
import { RouterConfig } from '@edikk-edikk/shared';
import { useAdvertDetailContext } from '#advertDetail/hooks';
import advertDetailHeaderInfoCss from '../../assets/header/header-info.module.scss';
import advertDetailHeaderTitleCss from '../../assets/header/header-title.module.scss';
import advertDetailHeaderLocationCss from '../../assets/header/header-location.module.scss';

const HeaderInfo: FC = () => {
  const {
    advert: {
      name,
      city,
    },
  } = useAdvertDetailContext();

  return (
    <div className={advertDetailHeaderInfoCss.advertDetailHeaderInfo}>
      <h1 className={advertDetailHeaderTitleCss.advertDetailHeaderTitle}>
        {name}
      </h1>
      <div className={advertDetailHeaderLocationCss.advertDetailHeaderLocation}>
        <FormattedMessage defaultMessage="Available in:" />
        <Link
          to={city.url}
          state={{ routerConfig: RouterConfig.initForCity(city.id) }}
          className={advertDetailHeaderLocationCss.advertDetailHeaderLocation__value}
        >
          {city.title}
        </Link>
      </div>
    </div>
  );
};

export { HeaderInfo };
